import { render, staticRenderFns } from "./Liquidacion.vue?vue&type=template&id=59a31bb2&scoped=true"
import script from "./Liquidacion.vue?vue&type=script&lang=js"
export * from "./Liquidacion.vue?vue&type=script&lang=js"
import style0 from "./Liquidacion.vue?vue&type=style&index=0&id=59a31bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a31bb2",
  null
  
)

export default component.exports